export default __webpack_public_path__ + "static/media/LunchPaperVouchers.3c13baba.jpg";